import { render } from "./manageRootControlMap.vue?vue&type=template&id=46facf69&scoped=true&ts=true"
import script from "./manageRootControlMap.vue?vue&type=script&lang=ts"
export * from "./manageRootControlMap.vue?vue&type=script&lang=ts"

import "./manageRootControlMap.vue?vue&type=style&index=0&id=46facf69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46facf69"]])

export default __exports__